import { Link } from "react-router";
import { translate } from "../translations/index";
import { getImageFromS3 } from "../utils";
import { useEffect, useState } from "react";
import APIclient from "../api-client";

export default function Footer() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    APIclient.partners.index().then(setPartners);
  }, []);

  return (
    <footer className="footer">
      <div className="footer__top">
        <a
          href={translate("layout.footer.instagram.url")}
          className="footer__link footer__link--icon"
          aria-label={translate("layout.footer.instagram.label")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="currentcolor"
          >
            <path d="M6.37602 1.31021C5.44477 1.35396 4.80914 1.50271 4.25352 1.72084C3.67852 1.94521 3.19102 2.24584 2.70539 2.73271C2.22039 3.21959 1.92164 3.70771 1.69914 4.28334C1.48352 4.84021 1.33789 5.47646 1.29664 6.40834C1.25539 7.33959 1.24664 7.63959 1.25102 10.0152C1.25539 12.3908 1.26602 12.689 1.31102 13.6227C1.35539 14.5533 1.50352 15.189 1.72164 15.7452C1.94602 16.3202 2.24664 16.8077 2.73352 17.2933C3.22039 17.7783 3.70789 18.0765 4.28539 18.2996C4.84164 18.5146 5.47852 18.6615 6.40977 18.7021C7.34102 18.7427 7.64102 18.7521 10.0166 18.7477C12.3923 18.7433 12.691 18.7327 13.6248 18.6883C14.5585 18.644 15.1904 18.4952 15.7466 18.2777C16.3216 18.0527 16.8098 17.7527 17.2948 17.2652C17.7798 16.7777 18.0785 16.2896 18.3004 15.7133C18.516 15.1571 18.6623 14.5202 18.7029 13.5896C18.7435 12.6558 18.7535 12.3577 18.7485 9.98146C18.7435 7.60522 18.7335 7.30772 18.6891 6.37459C18.6448 5.44146 18.4966 4.80771 18.2785 4.25146C18.0535 3.67646 17.7535 3.18896 17.2666 2.70334C16.7798 2.21771 16.291 1.91959 15.7148 1.69771C15.1579 1.48209 14.5216 1.33521 13.5904 1.29521C12.6591 1.25521 12.3591 1.24459 9.98289 1.24896C7.60664 1.25334 7.30914 1.26396 6.37602 1.30896M6.47852 17.1271C5.62539 17.0902 5.16227 16.9483 4.85352 16.8296C4.44477 16.6721 4.15352 16.4815 3.84602 16.1771C3.53852 15.8727 3.34914 15.5802 3.18977 15.1721C3.06977 14.8633 2.92539 14.4008 2.88539 13.5477C2.84227 12.6258 2.83289 12.349 2.82789 10.0127C2.82289 7.67646 2.83164 7.40021 2.87227 6.47771C2.90852 5.62521 3.05102 5.16146 3.16977 4.85271C3.32727 4.44334 3.51727 4.15271 3.82227 3.84521C4.12727 3.53771 4.41914 3.34834 4.82727 3.18896C5.13539 3.06834 5.59852 2.92521 6.45102 2.88459C7.37352 2.84084 7.65039 2.83209 9.98602 2.82709C12.3216 2.82209 12.5991 2.83084 13.5223 2.87146C14.3748 2.90834 14.8385 3.04959 15.1466 3.16896C15.5554 3.32646 15.8466 3.51584 16.1541 3.82146C16.4616 4.12709 16.651 4.41771 16.811 4.82709C16.9316 5.13459 17.0748 5.59709 17.1148 6.45021C17.1585 7.37271 17.1685 7.64959 17.1729 9.98521C17.1773 12.3208 17.1691 12.5983 17.1285 13.5202C17.091 14.3733 16.9498 14.8365 16.831 15.1458C16.6735 15.5546 16.4835 15.8458 16.1779 16.1533C15.8723 16.4608 15.581 16.6502 15.1729 16.8096C14.8648 16.9296 14.4016 17.0733 13.5498 17.114C12.6273 17.1571 12.3504 17.1665 10.0141 17.1715C7.67789 17.1765 7.40102 17.1671 6.47852 17.1271ZM13.6116 5.32209C13.6129 5.90209 14.0835 6.37146 14.6635 6.37021C15.2435 6.36896 15.7129 5.89834 15.7116 5.31834C15.7104 4.73834 15.2398 4.26896 14.6598 4.27021C14.0798 4.27146 13.611 4.74209 13.6116 5.32209ZM5.50727 10.0071C5.51227 12.4883 7.52727 14.4958 10.0085 14.4908C12.4898 14.4858 14.4979 12.4708 14.4935 9.98959C14.4885 7.50834 12.4729 5.50021 9.99164 5.50521C7.51039 5.51021 5.50227 7.52584 5.50727 10.0071ZM7.08414 10.004C7.08102 8.39334 8.38414 7.08459 9.99539 7.08146C11.606 7.07834 12.9148 8.38146 12.9179 9.99271C12.921 11.6033 11.6179 12.9121 10.0066 12.9152C8.39602 12.9183 7.08727 11.6158 7.08414 10.0052" />
          </svg>
        </a>
        <Link className="footer__link" to="/privacy">
          {translate("layout.footer.privacy")}
        </Link>
      </div>
      <div className="footer__partners">
        {Object.values(partners).map((partner) => (
          <Link
            to={partner.website}
            key={partner._id}
            target="_blank"
            rel="noopener"
            className="footer__partner"
          >
            <img
              className="footer__logo"
              src={getImageFromS3(`partner/${partner._id}`)}
              alt={partner.name}
            />
          </Link>
        ))}
      </div>
    </footer>
  );
}
